import { memo } from 'react';

import SlashIconSVG from '@/assets/slash-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISlashIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={SlashIconSVG} {...props} />;

export const SlashIcon = memo(ISlashIcon) as typeof ISlashIcon;
